const PRODUCT_TYPE_MAP = {
  'high-yield-online-savings-accounts': 'savings account',
  'cd-rates': 'CD',
  'checking-accounts': 'checking account',
  'free-checking-accounts': 'checking account',
  'online-checking-accounts': 'checking account',
  'compound-interest-calculator': 'saving account',
};

export function getProductTypeFromSlug(slug: string) {
  return PRODUCT_TYPE_MAP[slug as keyof typeof PRODUCT_TYPE_MAP];
}
